import {
  FETCH_BROKER_SETTINGS_REQUEST,
  FETCH_BROKER_SETTINGS_SUCCESS,
  FETCH_BROKER_SETTINGS_FAILURE,
  FETCH_BROKER_SETTINGS_RESET,
  FETCH_BROKER_SETTINGS_LOADING,
  BROKER_SETTINGS_UPDATE_FIELD_VALUE,
  BROKER_SETTINGS_EDIT_FIELD,
} from '../../constants/ActionTypes';
import { updateBrokerEditField, updateBrokerFieldValue } from './updators';

const brokerSettings = (
  state = {
    data: {},
    dataFormatted: [],
    isFetching: false,
    loading: false,
    errors: {},
    formData: {},
  },
  action
) => {
  switch (action.type) {
    case FETCH_BROKER_SETTINGS_REQUEST:
      return { ...state, data: {}, isFetching: true, errors: {} };
    case FETCH_BROKER_SETTINGS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        errors: {},
        data: action.data.data,
        dataFormatted: action.dataFormatted,
      };
    case FETCH_BROKER_SETTINGS_FAILURE:
      return {
        ...state,
        data: {},
        dataFormatted: [],
        isFetching: false,
        errors: action.error,
      };
    case FETCH_BROKER_SETTINGS_LOADING:
      return {
        ...state,
        loading: action.value,
      };
    case BROKER_SETTINGS_UPDATE_FIELD_VALUE:
      return {
        ...state,
        formData: updateBrokerFieldValue(state, action),
      };
    case BROKER_SETTINGS_EDIT_FIELD:
      return {
        ...state,
        ...updateBrokerEditField(state, action),
      };
    case FETCH_BROKER_SETTINGS_RESET:
      return {
        ...state,
        data: {},
        isFetching: false,
        loading: false,
        errors: {},
        formData: {},
        dataFormatted: [],
      };

    default:
      return state;
  }
};

export default brokerSettings;
